// eslint-disable-next-line @typescript-eslint/no-var-requires -- 暫定対処でdisableしてごめんなさい
const settings = require(`./_${process.env.APP_ENV}`);

export default settings;
